/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowRoundTimeBackIcon20Regular = forwardRef('ArrowRoundTimeBackIcon20Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M7.569 3.974a6.499 6.499 0 1 1-3.421 8.852.75.75 0 0 0-1.35.652 7.999 7.999 0 1 0 .702-8.14V2.756a.75.75 0 0 0-1.5 0v4.5c0 .415.336.75.75.75H7a.75.75 0 1 0 0-1.5H4.521A6.499 6.499 0 0 1 7.57 3.974Z" })));
});
